import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initErrorTracking } from './errorTracking';
import { installAiProductAnalyticsForwarding } from './utils/installAiProductAnalyticsForwarding';
import { bootstrapLegacyHashRoute } from './app/legacy-hash-routes';

initErrorTracking();
installAiProductAnalyticsForwarding();
bootstrapLegacyHashRoute();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

